package com.partejar.app.feature.convite.data.remote

import kotlinx.serialization.Serializable

@Serializable
data class ConviteAceiteDetailsDto(
    val nomeConvidado: String,
    val email: String,
    val workspaceNome: String,
    val perfilNome: String,
    val categoriaProfissional: String,
    val expiraEm: String,
    val usuarioExistente: Boolean
)

@Serializable
data class AceitarConviteDto(val token: String, val nome: String? = null, val senha: String? = null)

@Serializable
data class AceitarConviteLegadoDto(val nome: String? = null, val senha: String? = null)

@Serializable
data class ValidarConviteDto(val token: String)

@Serializable
data class AceitarConviteResponseDto(
    val accessToken: String,
    val refreshToken: String,
    val workspaceId: Long
)
